import { FunctionAction } from '@cgs/wge';
import { SoundInstance } from '../sound_instance';

export class PlaySoundAction extends FunctionAction {
  constructor(sound: SoundInstance | (() => void)) {
    super(sound instanceof SoundInstance ? () => sound.play() : sound);
  }
}
